import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';
import type { Root, Text, Parent, Link } from 'mdast';

const remarkHashLinks: Plugin<[basePath?: string], Root> = (
    basePath = '/records/'
) => {
    return (tree) => {
        visit(
            tree,
            'text',
            (
                node: Text,
                index: number | undefined,
                parent: Parent | undefined
            ) => {
                if (index == null || !parent) return;
                const value = node.value ?? '';
                if (!value) return;

                const regex = /#([a-z0-9]+(?:-[a-z0-9]+){2,})/gi;
                let match: RegExpExecArray | null;
                let last = 0;
                const newNodes: Array<Text | Link> = [];

                while ((match = regex.exec(value))) {
                    const start = match.index;
                    const end = start + match[0].length;

                    // boundary: start-of-string OR one of space, tab, newline, (, [, {
                    const prev = start > 0 ? value[start - 1]! : '';
                    const boundaryOK =
                        start === 0 ||
                        prev === ' ' ||
                        prev === '\t' ||
                        prev === '\n' ||
                        prev === '(' ||
                        prev === '[' ||
                        prev === '{';
                    if (!boundaryOK) continue;

                    if (start > last) {
                        newNodes.push({
                            type: 'text',
                            value: value.slice(last, start),
                        });
                    }

                    const triplet = match[1]!;
                    newNodes.push({
                        type: 'link',
                        url: `${basePath}${triplet}`,
                        title: null,
                        children: [{ type: 'text', value: `#${triplet}` }],
                    });

                    last = end;
                }

                if (newNodes.length) {
                    if (last < value.length) {
                        newNodes.push({
                            type: 'text',
                            value: value.slice(last),
                        });
                    }
                    parent.children.splice(
                        index,
                        1,
                        ...(newNodes as unknown as Parent['children'])
                    );
                }
            }
        );
    };
};

export default remarkHashLinks;
